module.exports = __webpack_public_path__ + "static/media/badge_118.a905d254.png";